import e from "./highrise1841.mjs";
var n = "__lodash_hash_undefined__", o = Object.prototype, _ = o.hasOwnProperty;
function h(a) {
  var r = this.__data__;
  if (e) {
    var t = r[a];
    return t === n ? void 0 : t;
  }
  return _.call(r, a) ? r[a] : void 0;
}
export {
  h as default
};
